function getMetaValue(name, defaultVal = '') {
    let el = document.querySelector('meta[name=' + name + ']')
    return el ? el.content : defaultVal
}

const settings = {
    APP_NAME: getMetaValue('APP_NAME'),
    APP_URL: getMetaValue('APP_URL'),
    API_URL: getMetaValue('API_URL'),
    APP_URL_2: getMetaValue('APP_URL_2'),
    API_URL_2: getMetaValue('API_URL_2'),
    AUTH_TOKEN: getMetaValue('bearer'),
    CSRF_TOKEN: getMetaValue('csrf-token'),
    IS_DEV_MODE: getMetaValue('mode', false),
    TYPE: getMetaValue('type', false),
    BRAND_ID: getMetaValue('brand_id')
}

export default settings
